import { MapPin } from "lucide-react";
import { geoAnomalyText } from "@/lib/geo";

// Dettaglio causa "Fuori area geolocalizzazione" (distanza e tolleranza; mai coordinate grezze).
export function GeoAnomalyNote({ phase, geo, testid, className = "" }) {
  const t = geoAnomalyText(phase, geo);
  if (!t) return null;
  return (
    <div className={`flex items-start gap-1.5 text-xs text-amber-700 ${className}`} data-testid={testid}>
      <MapPin className="h-3.5 w-3.5 mt-0.5 shrink-0" />
      <div>
        <p className="font-semibold">{t.title}</p>
        <p>{t.detail}</p>
        <p>{t.tolerance}</p>
      </div>
    </div>
  );
}
